import { render, staticRenderFns } from "./modifyintervention.vue?vue&type=template&id=5acff3a4&scoped=true&"
import script from "./modifyintervention.vue?vue&type=script&lang=js&"
export * from "./modifyintervention.vue?vue&type=script&lang=js&"
import style0 from "./modifyintervention.vue?vue&type=style&index=0&id=5acff3a4&lang=scss&scoped=true&"
import style1 from "./modifyintervention.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5acff3a4",
  null
  
)

export default component.exports